import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_layout/aircraft_/$aircraftId/")({
  component: Empty,
})

function Empty(): React.ReactElement {
  return <span />
}
